export const ValidateText = ({ text, length }) => {
  if (text) {
    return text.length >= length
  }
  return null
}

export const ValidationNumber = ({ number, test: { value, validation }}) => {
  if (number && number !== '') {
    const test = parseInt(number)

    if (isNaN(test)) {
      return false
    }

    switch (validation) {
      case '>': return test > value
      case '>=': return test >= value
      case '<': return test < value
      case '<=': return test <= value
      case '===': case '==': return test === value
      default: return null
    }
  }
  return null
}

export const ValidationEmail =  ({ email }) => {
  const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regExp.test(String(email).toLowerCase())
}
